import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { CButton } from "../components";

export default function FindHatm() {

    function handleSubmit(event) {
        event.preventDefault();

        const data = new FormData(event.currentTarget);

        window.location = `/hatimler/${data.get('hatmId')}`
    }

    return <Box margin={"30px 0px"}>
        <h3>Kod ile Hatim Bul</h3>
        <Box component="form" onSubmit={handleSubmit}>
            <TextField
                margin="dense"
                autoComplete="hatim"
                name="hatmId"
                required
                fullWidth
                id="hatmId"
                label="Hatim Kodunu Giriniz"
            />
            <CButton>Hatime Git</CButton>
        </Box>
    </Box>
}